import GuestSignInLogo from '../GuestSignInLogo';
import FacebookIcon from './FacebookIcon';
import InstagramIcon from './InstagramIcon';
import LinkedInIcon from './LinkedInIcon';
import LocationIcon from './LocationIcon';
import PhoneIcon from './PhoneIcon';
import TwitterIcon from './TwitterIcon';
import YouTubeIcon from './YouTubeIcon';
import { NavLink } from 'react-router-dom';

export default function HeaderSubMenu() {
  const currentYear = new Date().getFullYear();
  return (
    <div className='header-sub-menu'>
      <div className='sub-menu profile-sub-menu'>
        {/* <div className='pic-wrap pic-wrap-placeholder'>
          <GuestSignInLogo fillColor={'#2572a2'} />
        </div> */}
        <div className='guest-icon-wrapper' style={{ pointerEvents: 'none' }}>
          <GuestSignInLogo fillColor={'var(--blue-text-bold)'} />
        </div>
        <div className='sub-menu-content'>
          <h6 className='user-name'> Guest User</h6>
        </div>
      </div>
      <div className='sub-menu about-sub-menu'>
        <div>
          <NavLink
            to='/swapandtop/tou'
            className='selectable-text sub-menu-links'>
            View terms of use
          </NavLink>
          <NavLink
            to='/swapandtop/privacypolicy'
            className='selectable-text sub-menu-links'>
            View privacy policy
          </NavLink>
          <NavLink
            to='/swapandtop/tipsandrecomandations'
            className='selectable-text sub-menu-links'>
            View tips & recomendations
          </NavLink>
        </div>
      </div>

      <div className='sub-menu contact-us-submenu'>
        <div className='contact-details-wrap'>
          <div className='contact-details'>
            <PhoneIcon svgClass={'header-icon contact-details-icons'} />
            <div>
              <p>+263774 689 010</p>
              <p>+263784 224 614</p>
              <p>+263719 217 717</p>
            </div>
          </div>
          <div className='contact-details'>
            <LocationIcon svgClass={'header-icon contact-details-icons'} />
            <div>
              <p>4442 Ceres Ave</p>
              <p>Waterfalls</p>
              <p>Harare</p>
            </div>
          </div>
        </div>
      </div>
      <div className='sub-menu socials-sub-menu'>
        <div className='feedback-sub-menu'>
          <p>Your feedback is very iportant to us.</p>
          <p>Please e-mail us at</p>
          <a className='selectable-text'>feedback@swapandtop.co.zw</a>
        </div>
        <div className='socials-sub-menu-icons-wrap'>
          <p>Check us out on social</p>
          <div className='socials-icons-wrap'>
            <a href='https://www.facebook.com' target='_blank'>
              <FacebookIcon socialIconClass={'social-icon'} />
            </a>
            <a href='https://www.twitter.com' target='_blank'>
              <TwitterIcon socialIconClass={'social-icon'} />
            </a>
            <a href='https://www.youtube.com' target='_blank'>
              <YouTubeIcon socialIconClass={'social-icon'} />
            </a>
            <a href='https://www.instagram.com' target='_blank'>
              <InstagramIcon socialIconClass={'social-icon'} />
            </a>
            <a href='https://www.linkedin.com' target='_blank'>
              <LinkedInIcon socialIconClass={'social-icon'} />
            </a>
          </div>
        </div>
        <div className='sub-menu-company-name'>
          <a className='selectable-text'>© {currentYear} | Greta Works Inc.</a>
        </div>
      </div>
    </div>
  );
}
